module.exports = __webpack_public_path__ + "img/combo_6.40170088.png";